import React, { Component } from "react"
import { Nav } from "react-bootstrap"
import { GetSinglePageAppPath } from "../../BaseUrl"
import { Home, AboutRoute } from "../../config/Routes"

export interface LoginNavMenuProps {
  active?: string
}

export class LoginNavMenu extends Component<LoginNavMenuProps, {}> {
  linkTo = (route: string, caption: string) => <Nav.Link href={`${GetSinglePageAppPath()}#${route}`} bsPrefix="btn btn-link">{caption}</Nav.Link>

  render() {
    return (
      <Nav>
        <Nav.Item>
          {this.linkTo(Home, "Home")}
        </Nav.Item>
        {/*<Nav.Item>
          {this.linkTo(AboutRoute, "About")}
        </Nav.Item>*/}
      </Nav>)
  }
}
